import { Injectable } from '@angular/core';
import { CustomerApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { CustomerAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class CustomerEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(CustomerAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => CustomerAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: CustomerApiService, private _actions$: Actions, private _store: Store) {}
}
